const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' })

export function compareFileNames(a: string, b: string): number {
  const order = collator.compare(a, b)
  if (order !== 0) return order
  // 數值相等時較少補零者優先，再以 code point 決勝，避免目錄列舉順序影響頁碼。
  return a.length - b.length || (a < b ? -1 : a > b ? 1 : 0)
}

export function naturalSort(names: readonly string[]): string[] {
  return [...names].sort(compareFileNames)
}
